import ApiService from '../../../shared/services/api-service';
import commonActionCreators from '../../../shared/store/common/action-creators';
import ftosActionCreators from '../ftos/action-creators';
import oitsCommitTypes from './commit-types';
import notificationsActionsCreator from '../notifications/action-creators';

const oitsActionCreators = {
  assignFtoToPhase(formData) {
    const patch = { ...formData };
    delete patch.trainingTrackerGuid;
    return async (dispatch) => {
      dispatch(this.setIsLoading('assignFtoToPhase'));
      const data = await ApiService.patch(`/api/v1/training-trackers/${formData.trainingTrackerGuid}`, patch)
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.reject();
        });
      dispatch(this.setIsLoading('assignFtoToPhase'));
      if (data) {
        dispatch(this.assignFtoToPhaseSuccess(data));
      }
      return Promise.resolve();
    };
  },
  assignFtoToPhaseSuccess(oitResponse) {
    return (dispatch) => {
      dispatch(this.replaceOit(oitResponse.data));
      dispatch(this.closeAssignFto());
      dispatch(notificationsActionsCreator.addSavedSuccessfully('Fto assigned'))
    };
  },
  closeAssignFto() {
    return (dispatch) => {
      dispatch(this.setIsAssigningFtoFor(null));
      dispatch(ftosActionCreators.resetFtosState());
    };
  },
  closePhase(formData) {
    return async (dispatch) => {
      // Setup request data
      const patch = { ...formData };
      delete patch.guid;
      dispatch(this.setIsLoading('closePhase'));
      const data = await ApiService.patch(`/api/v1/training-trackers/${formData.guid}`, patch)
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.reject();
        });
      dispatch(this.setIsLoading('closePhase'));
      if (data) {
        dispatch(this.closePhaseSuccess(data));
      }
      return Promise.resolve();
    };
  },
  closePhaseSuccess(closePhaseResponse) {
    return (dispatch) => {
      dispatch(this.replaceOit(closePhaseResponse.data));
      dispatch(notificationsActionsCreator.addSavedSuccessfully('Phase closed'))
    };
  },
  fetchOit(oitGuid) {
    return async (dispatch) => {
      dispatch(this.setIsLoading('fetchOit'));
      const data = await ApiService.get(`/api/v1/oits/${oitGuid}`)
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.reject();
        });
      dispatch(this.setIsLoading('fetchOit'));
      if (data) {
        dispatch(this.fetchOitSuccess(data));
      }
      return Promise.resolve();
    };
  },
  fetchOitSuccess(oitResponse) {
    return (dispatch) => {
      dispatch(this.replaceOit(oitResponse.data));
    };
  },
  fetchOits() {
    return async (dispatch) => {
      dispatch(this.setIsLoading('fetchOits'));
      const data = await ApiService.get('/api/v1/oits')
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.reject();
        });
      dispatch(this.setIsLoading('fetchOits'));
      if (data) {
        dispatch(this.fetchOitsSuccess(data));
      }
      return Promise.resolve();
    };
  },
  fetchOitsSuccess(oitsResponse) {
    return (dispatch) => {
      dispatch(this.pushOits(oitsResponse.data));
    };
  },
  loadOitsContainer() {
    return (dispatch) => {
      return dispatch(this.fetchOits());
    };
  },
  openAssignFto(phaseGuid) {
    return (dispatch) => {
      dispatch(this.setIsAssigningFtoFor(phaseGuid));
      dispatch(ftosActionCreators.fetchFtosForTrainingPhase(phaseGuid));
    };
  },
  openPhase(formData) {
    return async (dispatch) => {
      // Setup request data
      const patch = { ...formData };
      delete patch.guid;
      dispatch(this.setIsLoading('openPhase'));
      const data = await ApiService.patch(`/api/v1/training-trackers/${formData.guid}`, patch)
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.reject();
        });
      dispatch(this.setIsLoading('openPhase'));
      if (data) {
        dispatch(this.openPhaseSuccess(data));
      }
      return Promise.resolve();
    };
  },
  openPhaseSuccess(openPhaseResponse) {
    return (dispatch) => {
      dispatch(this.replaceOit(openPhaseResponse.data));
      dispatch(notificationsActionsCreator.addSavedSuccessfully('Phase opened'))
    };
  },
  pushOits(list) {
    return {
      list,
      type: oitsCommitTypes.PUSH_OITS,
    };
  },
  replaceOit(oit) {
    return {
      oit,
      type: oitsCommitTypes.REPLACE_OIT,
    };
  },
  setIsAssigningFtoFor(isAssigningFtoFor) {
    return {
      isAssigningFtoFor,
      type: oitsCommitTypes.SET_OIT_IS_ASSIGNING_FTO_FOR,
    };
  },
  setIsLoading(isLoading) {
    return {
      isLoading,
      type: oitsCommitTypes.SET_OITS_IS_LOADING,
    };
  },
  setSelectedOitGuid(selectedGuid) {
    return {
      selectedGuid,
      type: oitsCommitTypes.SET_SELECTED_OIT_GUID,
    };
  },
  unassignFtoFromPhase(formData) {
    const patch = { ...formData };
    delete patch.trainingTrackerGuid;
    return async (dispatch) => {
      dispatch(this.setIsLoading('unassignFtoFromPhase'));
      const data = await ApiService.patch(`/api/v1/training-trackers/${formData.trainingTrackerGuid}`, patch)
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.resolve();
        });
      dispatch(this.setIsLoading('unassignFtoFromPhase'));
      if (data) {
        dispatch(this.unassignFtoFromPhaseSuccess(data));
      }
      return Promise.resolve();
    };
  },
  unassignFtoFromPhaseSuccess(oitResponse) {
    return (dispatch) => {
      dispatch(this.replaceOit(oitResponse.data));
      dispatch(notificationsActionsCreator.addSavedSuccessfully('Fto unassigned'))
    };
  },
  unmountOitsContainer() {
    return {
      type: oitsCommitTypes.RESET_OITS_STATE,
    };
  },
};

export default oitsActionCreators;
